module.exports = __webpack_public_path__ + "static/img/36_pro.f40e1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/36_pro.jpg
// module id = 9M/s
// module chunks = 0